module.exports = "./img/df9c83a8f47e68cb801592beb6419bb5.png";